export default {
    header: {
        language: 'language',
        zh: 'Simplified Chinese',
        en: 'English',
        logOut: 'log out',
    },
    common: {
        cancel: 'Cancel',
        confirm: 'Confirm',
        search: 'Query',
        exportExcel: 'Export Excel',
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        select: 'Select',
        actions: 'Actions',
        view: 'View',
        choose:{
            yes:  'Yes',
            no: 'No'
        }
    },
    tags: {
        options: 'Tag Options',
        closeOthers: 'Close Others',
        closeAll: 'Close All'
    },
    menu: {
        home: 'Home',
        permission: 'Permission',
        permissionManage: 'Permission',
        roleManage: 'Role',
        userManage: 'User',
        cost: 'Cost',
        companyCost: 'Company Cost',
        fixedCost: 'Fixed Cost',
        specialFee: 'Special Fee',
        feeStandard: 'Fee Standard',
        storedValue: 'Stored Value Records',
        order: 'Order',
        addOrder: 'Add Order',
        orderManage: 'Order Management',
        accountManage: 'Account',
        accountInfo: 'Account Info',
        userAddress: 'User Address',
        noticeManage: 'Announcement',
        discountApply: 'Discount',
        orderDetail: 'Order Detail',
        invoiceManage: 'Invoice Management',
        invoiceTitleManage: 'Invoice Title Management',
        SupplierOrderManager: 'Supplier Order Management',
        FeesDataShow: 'Fees Data Show',
        OtherChargeStandard: 'Other Fee Standard',
        changePassword: 'Change Password',
        authGroupManage: 'Auth Group Management'
    },
    home: {
        welcome: 'Welcome to Smart Logistics Management Platform',
        subtitle: 'Monitor your logistics data and order status in real-time',
        balanceAvailable: 'Available Balance in Account',
        balanceWarning1: 'Due or cash orders will deduct balance. Failure to deduct will lead to overdue and prevent new orders.',
        creditLimit: 'Credit Limit',
        creditWarning1: 'To create credit orders, ensure:',
        creditWarning2: 'Available balance + Credit limit > Total bill + Unfinished order amount',
        billAmount: 'Total Bill',
        unfinishedOrderAmount: 'Unfinished Order Amount',
        announcement: 'Announcement',
        updatedAt: ' Updated'
    },
    specialFee: {
        add: 'Add',
        id: 'ID',
        name: 'Fee Name',
        price: 'Amount',
        description: 'Description',
        addDialogTitle: 'Add Special Fee',
        editDialogTitle: 'Update Special Fee',
        namePlaceholder: 'Enter fee name',
        pricePlaceholder: 'Enter amount',
        descriptionPlaceholder: 'Enter description'
    },
    chargeStandard: {
        payType: 'Payment Type',
        deliveryType: 'Delivery Type',
        address: 'Address',
        addressPlaceholder: 'Enter address',
        price: 'Price ($)',
        pricePlaceholder: 'Enter price',
        description: 'Description',
        descriptionPlaceholder: 'Enter description',
        start: 'Create Time',
        end: 'Update Time',
        range: 'Search Range',
        addDialog: 'Add Charge Standard',
        editDialog: 'Edit Charge Standard',
        select: 'Please select',
        currentStandards: 'Current Standards',
        allStandards: 'All Standards',
        extraFeeTips: `Other Fees (charged and shown during the order process, only for the west US. For others, contact support):\n
Fixed Fees (Pier Pass + CTF): 20ft: $50.00, 40/45ft: $100.00 Some areas may vary\n
Chassis:  $40/day（Charter frame fees apply in certain regions, please contact customer service for details） Special frames are excluded\n`
    },
    balance: {
        userId: 'User ID',
        description: 'Description',
        type: 'Balance Type',
        number: 'Amount($)',
        image: 'Image',
        payType: 'Deduction Cycle (used in settlement)',
        createTime: 'Created Time',
        operation: 'Actions',
        startTime: 'Start Time',
        endTime: 'End Time',
        uploadRecord: 'Upload Top-up Record',
        exportBill: 'Export Bill',
        viewAccount: 'View Payment Account',
        openInvoice: 'Open Invoice',
        uploadImage: 'Upload Image',
        edit: 'Edit',
        addTitle: 'Add Balance',
        editTitle: 'Edit Balance',
        clientId: 'Client ID',
        currency: 'Currency',
        amount: 'Amount($)',
        paymentMethod: 'Payment Method',
        upload: 'Upload',
        view: 'View',
        deleteConfirm: 'Are you sure to delete the file?',
        uploadImageDialog: 'Upload Image',
        viewImage: 'View Image',
        currentRate: 'Current Exchange Rate:',
        account: 'Account',
        usAccount: 'U.S. Account',
        cnAccount: 'Mainland China Account',
        company: 'Company',
        bank: 'Bank',
        address: 'Address',
        swift: 'SWIFT Code',
        ach: 'ACH Routing#',
        wires: 'Wires RT#',
        accountNumber: 'Account#',
        paymentTip: '💡 Please remit payment to the account based on your region.',
        zhNumber:'Amount(￥)',
        status:{
            "-2": "Failed",
            "-1": "Submitted (Pending Review)",
            "0": "Top-up (Pending)",
            "1": "Credit Consumption",
            "2": "Credited",
            "3": "Consumed",
            "4": "Refunded",
            "undefined":""

        }
    },
    order: {
        baseInfoTip: 'Basic Information (The price will be calculated automatically after filling in. If the delivery address cannot be found or the price is empty, please contact customer service.)',
        userId: 'User ID',
        inputUserId: 'Please enter user ID',
        address: 'Delivery Address',
        manageAddress: 'Manage Address',
        dischargeType: 'Discharge Method',
        payType: 'Payment Method',
        size: 'Cargo Size',
        thing: 'Container Goods',
        inputThing: 'Enter Goods',
        specialType: 'Special Type',
        doInfo: 'DO Information (Can be completed later)',
        terminal: 'Terminal',
        shippingCompany: 'Shipping Company',
        cabinetNumber: 'Cabinet Number',
        inputCabinetNumber: 'Enter Cabinet Number',
        mbl: 'MBL',
        inputMbl: 'Enter MBL',
        estimatedArrival: 'Estimated Arrival Time',
        selectDate: 'Select Date',
        remarks: 'Remarks',
        inputRemarks: 'Enter Remarks',
        price: 'Price:',
        basicFee: 'Basic Fee',
        specialFee: 'Special Fee',
        ppCtf20: 'pp + ctf: 50$',
        ppCtf40: 'pp + ctf: 100$',
        viewSpecialFee: 'View Special Charges',
        total: 'Total Price:',
        priceNote: 'Basic price does not include overtime or storage fees',
        viewChargeStandard: 'View Pricing Standard',
        submit: 'Submit'
    },
    orderDetail: {
        orderEvents: 'Order Events',
        orderFees: 'Order Fees',
        internalEvent: 'Internal Event',
        orderStatus: 'Order Status',
        eventType: {
            消息事件: 'Message Event',
            异常事件: 'Exception Event'
        },
        feeStatus: 'Fee Generated at Status',
        feeAmount: 'Order Fee',
        image: 'Image',
        view: 'View',
        detail: 'Detail',
        viewImage: 'View Image'
    },
    orderStatus: {
        "100": "Order Created",
        "200": "Waiting for DO Entry",
        "300": "Information Verification",
        "400": "In Transit",
        "500": "Arrived at Port",
        "600": "Container Appointment Completed",
        "700": "About to Pick Up Container",
        "800": "Picking Up Container",
        "900": "Container Picked Up",
        "1000": "Waiting for Delivery to Warehouse",
        "1100": "Delivered to Warehouse",
        "1200": "Awaiting Empty Return",
        "1300": "Empty Return Appointment Completed",
        "1400": "Returning Empty Container",
        "1500": "Empty Return Successful",
        "1600": "Completed"
    },
    userInfo: {
        title: 'User Information',
        subtitle: 'Manage your personal information',
        personalInfo: 'Personal Information',
        oldPassword: 'Current Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm New Password',
        inputOldPassword: 'Enter current password',
        inputNewPassword: 'Enter new password',
        inputConfirmPassword: 'Re-enter new password',
        changePassword: 'Change Password',
        backToProfile: 'Back to Profile',
        passwordHint: 'Enter your current password and confirm your new password.',
        passwordMismatch: 'The new passwords do not match',
        passwordValidation: 'Enter the current password and matching new passwords',
        nameRequired: 'Name is required',
        updateSuccess: 'Changes saved',
        updateFailed: 'Unable to save changes. Please try again',
        id: 'ID',
        name: 'Name',
        password: 'Password',
        email: 'Email',
        address: 'Address',
        inputName: 'Enter name',
        inputPassword: 'Enter password',
        inputEmail: 'Enter email',
        inputAddress: 'Enter address',
        submit: 'Submit Changes'
    },
    address: {
        subtitle: 'Manage your delivery address information',
        tableTitle: 'Address List',
        userId: 'User ID',
        userIdPlaceholder: 'Enter User ID',
        select: 'Select Address',
        selectPlaceholder: 'Please select delivery address',
        detail: 'Detailed Address',
        detailPlaceholder: 'Enter address',
        standard: 'Charge Standard Address',
        addTitle: 'Add Address',
        editTitle: 'Edit Address'
    },
    orderManage: {
        createTime: 'Create Time',
        displayTitle: 'Display Title',
        orderByName: 'Order By Column',
        orderByType: 'Sort Type',
        payType: 'Payment Method',
        size: 'Cargo Size',
        terminal: 'Terminal',
        shippingCompany: 'Shipping Company',
        status: 'Order Status',
        mbl: 'MBL',
        cabinetNumber: 'Cabinet Number',
        id: 'ID',
        userId: 'User ID',
        timeType: 'Time Type',
        startTime: 'Start Time',
        endTime: 'End Time',
        todayOrder: 'View Today\'s Orders',
        clear: 'Clear',
        viewDetails: 'View Details',
        viewEvents: 'View Events',
        viewCharges: 'View Charges',
        fillDO: 'Fill DO Info',
        updateStatus: 'Update Status',
        completeOrder: 'Complete Order',
        statusButtonLabel:{
            500: 'Arrived, Awaiting Container Appointment',
            600: 'Container Appointment Completed',
            700: 'Container Pickup Tomorrow',
            800: 'Picking Up Container',
            1000: 'Delivering to Warehouse',
            1100: 'Delivered to Warehouse',
            1200: 'Awaiting Empty Container Return',
            1300: 'Empty Return Appointment Completed'
        },
        tatusUpdate: 'Status Update',
        editTitle: 'Edit Order',
        statusId: 'Order Status',
        dischargeType: 'Discharge Method',
        specialType: 'Special Type',
        basicFee: 'Basic Fee',
        thing: 'Item',
        address: 'Delivery Address',
        estimatedTimeArrival: 'Estimated Arrival Time',
        lastFreeDay: 'Last Free Day (LFD)',
        appointmentTime: 'Appointment for Pickup',
        reservationDeliveryTime: 'Appointment for Delivery',
        chassis: 'Chassis Number',
        enterDockTime: 'Enter Dock Time',
        leaveDockTime: 'Leave Dock Time',
        lastPerdiemTime: 'Last Per Diem Time',
        currentLocation: 'Current Container Location',
        startDeliveryTime: 'Start Delivery Time',
        finishDeliveryTime: 'Finish Delivery Time',
        emptyReadyTime: 'Empty Ready Time',
        emptyReservationTime: 'Empty Reservation Time',
        returnTerminal: 'Return Terminal',
        emptyGetTime: 'Empty Container Pickup Time',
        emptyReturnTime: 'Empty Container Return Time',
        sendDriverId: 'Delivery Driver ID',
        returnDriverId: 'Return Driver ID',
        remark: 'Order Remark',
        listTitle: 'Event List',
        add: 'Add Event',
        edit: 'Edit Event',
        type: 'Event Type',
        typePlaceholder: 'Select event type',
        time: 'Occurrence Time',
        selectTime: 'Select datetime',
        statusPlaceholder: 'Select order status',
        image: 'Image',
        confirmDelete: 'Are you sure you want to delete this file?',
        description: 'Event Description',
        descriptionPlaceholder: 'Enter event description',
        handle: 'Handling Result',
        handlePlaceholder: 'Enter handling result',
        upload: 'Upload Image',
        feeList: 'Fee List',
        addFee: 'Add Fee',
        editFee: 'Edit Fee',
        submitTime: 'Submission Time',
        amount: 'Amount ($)',
        descriptionFee: 'Fee Description',
        statusWhenGenerated: 'Status When Fee Generated',
        uploadImg: 'Upload Image',
        confirmDeleteFile: 'Are you sure to delete this file?',
        view: 'View',
        amountPlaceholder: 'Enter fee amount',
        descriptionPlaceholderFee: 'Enter fee description',
        statusPlaceholderFee: 'Select fee status',
        viewImage: 'View Image',
        remarks: 'Remark',
        specialTypeIds: 'Special Type',
        next: 'Proceed to Next Step',
        statusUpdate: 'Update Status',
        location: {
            "运输": "Transport",
            "暂存车场": "Temporary Storage",
        },
        orderByLabel:{
            create_time: "Create Time",
            status_id: "Status",
            desc: "Desc",
            asc: "Asc"
        },
        cargoSize: {
            20: "20 Feet",
            40: "40 Feet",
            45: "45 Feet"
        },
        orderFieldLabel: {
            userId: "User ID",
            id: "Order ID",
            statusId: "Order Status",
            payType: "Payment Type",
            dischargeType: "Discharge Method",
            specialTypeChoose: "Special Type",
            basicFee: "Basic Fee ($)",
            thing: "Item",
            mbl: "MBL Number",
            cabinetNumber: "Cabinet Number",
            size: "Cargo Size (inch)",
            shippingCompany: "Shipping Company",
            terminal: "Terminal",
            address: "Delivery Address",
            estimatedTimeArrival: "Estimated Arrival Time",
            lastFreeDay: "Last Free Day / LFD",
            appointmentTime: "Cabinet Appointment Time",
            reservationDeliveryTime: "Warehouse Delivery Reservation",
            chassis: "Chassis Number",
            enterDockTime: "Enter Dock Time",
            leaveDockTime: "Leave Dock Time",
            lastPerdiemTime: "Latest Empty Return Time",
            currentLocation: "Current Cabinet Location",
            startDeliveryTime: "Enter Dock Time",
            finishDeliveryTime: "Leave Dock Time",
            emptyReadyTime: "Empty Ready Time",
            emptyReservationTime: "Empty Return Reservation",
            returnTerminal: "Empty Return Terminal",
            emptyGetTime: "Empty Pickup Time",
            emptyReturnTime: "Empty Return Time",
            sendDriverId: "Delivery Driver ID",
            returnDriverId: "Return Driver ID",
            remark: "Order Remark",
            createTime: "Order Create Time",
        }
    },
    login: {
        systemName: 'Baobao International Logistics',
        welcomeMessage: 'Welcome to Baobao International Logistics Management Platform',
        usernamePlaceholder: 'Enter username',
        passwordPlaceholder: 'Enter password',
        login: 'Login',
        disclaimerPrefix: 'I have read and agree to',
        disclaimerConsent: 'I have read and agree to the Disclaimer and Claims Terms',
        disclaimerRequired: 'Please read and agree to the Disclaimer and Claims Terms first',
        closeDisclaimer: 'Close',
        acceptDisclaimer: 'I have read and agree',
        register: 'Register',
        forgotPassword: 'Forgot password?',
        verifyType: 'Verification Method',
        phone: 'Phone',
        email: 'Email',
        phonePlaceholder: 'Enter phone number',
        emailPlaceholder: 'Enter email',
        codePlaceholder: 'Enter verification code',
        getCode: 'Get Code',
        retryLater: ' to retry',
        newPasswordPlaceholder: 'Enter new password',
        submit: 'Submit',
        backToLogin: 'Back to Login',
        resetPassword: 'Reset Password',
        resetPasswordDesc: 'Please select verification method and enter relevant information'
    },
    register: {
        systemName: 'Baobao International Logistics',
        welcomeMessage: 'Welcome to Baobao International Logistics Management Platform',
        verifyType: 'Verification Method',
        accountPlaceholder: 'Enter account',
        nicknamePlaceholder: 'Enter name',
        passwordPlaceholder: 'Enter password',
        password2Placeholder: 'Re-enter password',
        email: 'Email',
        phone: 'Phone',
        emailVerifyPlaceholder: 'Enter verification email',
        phoneVerifyPlaceholder: 'Enter +86 phone number to verify',
        sendCode: 'Send code',
        retrySeconds: 's before retry',
        codePlaceholder: 'Enter verification code',
        emailContactPlaceholder: 'Enter contact email',
        phoneContactPlaceholder: 'Enter contact phone',
        addressPlaceholder: 'Address',
        licenseCodePlaceholder: 'Unified Social Credit Code',
        uploadLicense: 'Upload license photo (image or pdf)',
        chooseFile: 'Choose File',
        uploadTip: 'Supports JPG, JPEG, PNG, PDF formats, file size up to 10MB',
        uploadedFile: 'Uploaded file',
        toLogin: 'Back to Login',
        register: 'Register'
    }


}
